(function () {
    'use strict';

    angular
        .module('app')
        .factory('ftsService', ftsservice);

    ftsservice.$inject = ['$http', '$q', '$localStorage', 'breadCrumbService', 'loginService', 'lastSearchService'];

    function ftsservice($http, $q, $localStorage, breadCrumbService, loginService, lastSearchService) {
        var service = {
            getData: getData,
            ftsSearchId: "",
            searchCriteria: [],
            totalRecords: 0,
            getCount: getCount
        };
        var dataRequest = {};
        return service;

        //call to get data from the server
        function getData(skip, take, totalRecords, sort, sortOrder, countOperation, resultType, columns) {
            var responseType = resultType == 2 || resultType == 3 ? "arraybuffer" : "";
            if (service.searchCriteria.length == 0) {
                service.searchCriteria = $localStorage.userSettings["searchCriteria"];
            }
            else {
                $localStorage.userSettings["searchCriteria"] = service.searchCriteria;
            }

            service.searchCriteria[0].ftsSearchId = service.ftsSearchId;

            dataRequest = $q.defer();
            var canceller = $q.defer();

            var cancel = function (reason) {
                canceller.resolve(reason);
            }

            if (totalRecords == 0) {
                service.ftsSearchId = "";
            }

            breadCrumbService.category = loginService.resourceStrings["SEARCH"];

            

            service.processing = true;
            var request = $http({
                url: '../Synergis.WebApi/api/document/fulltextsearch/',
                method: 'POST',
                timeout: canceller.promise,
                responseType: responseType,
                data: JSON.stringify({
                    SearchCriteria: service.searchCriteria,
                    UserId: "",
                    Sort: { SortField: sort, SortOrder: sortOrder },
                    //ViewContext: "",
                    CountOperation: countOperation,
                    ResultType: resultType,
                    Columns: columns,
                    AdeptDataTable: {
                        TableDefinition: null,
                        TableRecords: null,
                        RecordCount: totalRecords,
                        Skip: skip,
                        Take: take,
                    }
                }),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                if (!response.data.CountOperation) {
                    if (response.data.SearchCriteria) {
                        service.ftsSearchId = response.data.SearchCriteria[0].ftsSearchId;
                        service.totalRecords = response.data.AdeptDataTable.RecordCount;
                    }                 
                }
                
                lastSearchService.getLastSearchAllOperations().then(function (value) {
                    breadCrumbService.details = value;
                    breadCrumbService.node = null;
                });
                service.processing = false;
                dataRequest.resolve(response);
            }, function (response) {
                service.processing = false;
                dataRequest.reject(response);
            });

            return {
                promise: dataRequest.promise,
                cancel: cancel
            }
        }

        function getCount() {
            var deferred = $q.defer();
            dataRequest.promise.then(function (response) {
                deferred.resolve(response.data.AdeptDataTable.RecordCount);
            })
            return deferred.promise;
        }
    }
})();